import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BbNgInit } from './bn-on-init';

@NgModule({
  imports: [CommonModule],
  declarations: [BbNgInit],
  exports: [BbNgInit],
})
export class BnOnInitModule {}
